import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'caret-up-down', 'CaretUpDown', [["path",{"d":"M18 10l-6 -6l-6 6h12","key":"svg-0"}],["path",{"d":"M18 14l-6 6l-6 -6h12","key":"svg-1"}]]);